import { createSlice, PayloadAction, SerializedError } from "@reduxjs/toolkit";
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";

export type ApplicationErrorType = string | FetchBaseQueryError | SerializedError;

interface ApplicationErrorState {
  error?: ApplicationErrorType | undefined;
}

export const ApplicationErrorSlice = createSlice({
  name: "applicationError",
  initialState: {} as ApplicationErrorState,
  reducers: {
    setErrors: (state, action: PayloadAction<ApplicationErrorType>) => ({
      ...state,
      error: action.payload
    }),

    clearErrors: (state) => ({
      ...state,
      error: undefined
    }),
  },
});

export const ApplicationErrorActions = ApplicationErrorSlice.actions;
export const ApplicationErrorReducer = ApplicationErrorSlice.reducer;